export default __webpack_public_path__ + "static/media/480_dummy2016-restaurant03-mobile-de.19a75062.png";